import { ApprovalStatus } from './registration-status.enum'

export const ApprovalStatusText = new Map()
  .set(ApprovalStatus.PENDING_REVIEW, 'Pending review')
  .set(ApprovalStatus.PENDING_PAYMENT, 'Pending payment')
  .set(ApprovalStatus.AWAITING_REVISION, 'Awaiting revision')
  .set(ApprovalStatus.UPDATED, 'Updated')
  .set(ApprovalStatus.APPROVED, 'Approved')
  .set(ApprovalStatus.DECLINED, 'Declined')
